import { Risk, ScopeFamily } from './types';

type SelectionState = 'all' | 'some' | 'none';

export function allScopeNames(families: ScopeFamily[]): string[] {
  return families.flatMap((family) =>
    family.resources.flatMap((resource) =>
      resource.scopes.map((scope) => scope.name)
    )
  );
}

export function namesByRisk(families: ScopeFamily[], risks: Risk[]): string[] {
  const riskSet = new Set(risks);
  return families.flatMap((family) =>
    family.resources.flatMap((resource) =>
      resource.scopes
        .filter((scope) => riskSet.has(scope.risk))
        .map((scope) => scope.name)
    )
  );
}

export function selectionState(
  names: string[],
  selected: Set<string>
): SelectionState {
  const selectedCount = names.filter((name) => selected.has(name)).length;
  if (selectedCount === 0) {
    return 'none';
  }
  return selectedCount === names.length ? 'all' : 'some';
}

export function withAdded(selected: Set<string>, names: string[]): Set<string> {
  const next = new Set(selected);
  names.forEach((name) => next.add(name));
  return next;
}

export function withRemoved(
  selected: Set<string>,
  names: string[]
): Set<string> {
  const next = new Set(selected);
  names.forEach((name) => next.delete(name));
  return next;
}
